// DO NOT USE THIS. WE HAVE RMA-V2 NOW
export enum RmaStatusEnum {
  Others = 999
}
